/** @format */

// services/dirRegistry.js

import routes from '@/config/routes';

export default {
  // --- simple API ---
  job: {
    url: '/accounting/dir/job/select',
  },

  office: {
    url: '/accounting/dir/office/select',
  },

  storage: {
    url: '/accounting/dir/storage/select',
  },

  metro: {
    url: '/mechti/underground_stations/select',
  },

  department: {
    url: '/accounting/dir/department/select',
  },

  category: {
    url: '/accounting/dir/service_category/select',
    byId: (id) => `/accounting/dir/service_category/select?filters={"id":${id}}`,
  },

  investor: {
    url: '/mechti/investors/select',
  },

  client: {
    url: '/mechti/clients/select',
    byId: (id) => `/mechti/clients/select?filters={"id":${id}}`,
  },

  residential_complex: {
    url: '/mechti/residential_complex/select',
  },

  // --- employee ---
  employee: {
    url: '/accounting/dir/employee',
    byId: (id) => `/accounting/dir/employee/${id}`,
    transform: (data) =>
      (data || []).map((r) => ({
        value: r.id,
        text: r.name,
        department_id: r.department_id,
        user_id: r.user_id,
        job_id: r.job_id,
      })),
  },

  // --- vendor ---
  vendor: {
    url: '/accounting/dir/vendor/select',
    byId: (id) => `/accounting/dir/vendor/select?filters={"id":${id}}`,
    transform1: (data) =>
      (data || []).map((d) => ({
        id: d.id,
        value: d.id,
        text: d.name,
        document_types: d.document_types,
      })),
  },

  // --- service ---
  service: {
    url: '/accounting/dir/service',
    byId: (id) => `/accounting/dir/service/${id}`,
    transform: (data) =>
      (data || []).map((d) => ({
        ...d,
        value: d.id,
        text: d.name,
        disabled: d.status !== null && d.status == 2,
      })),
  },

  // --- cashbox ---
  cashbox: {
    url: '/accounting/dir/cashbox/select',
    transform: (data) =>
      (data || []).map((d) => ({
        ...d,
        isActive: d.status !== 2,
      })),
  },

  // --- object ---
  object: {
    url: '/mechti/objects/select',
    byId: (id) => `/mechti/objects/select?filters={"id":${id}}`,
    /*    params: {
      filters: { name: { condition: '<>', value: '' } },
    },
  */
    transform: (data) =>
      (data || [])
        .filter((o) => {
          return o.name !== '';
        })
        .map((o) => ({
          ...o,
          isActive: o.status >= 0,
        })),
  },

  // --- objectProps ---
  objectProps: {
    url: 'mechti/object_props/select',
    transform: (data) =>
      (data || []).map((d) => ({
        ...d,
        isActive: d.status !== 2,
      })),
  },

  // --- user ---
  user: {
    url: '/mechti/tasks/users/select',
    byId: (id) => `/mechti/tasks/users/select?filters={"id":${id}}`,
    transform: (data) => {
      const res = (data || []).map((d) => ({
        ...d,
        isActive: d.status == 1,
      }));

      res.push({ value: 0, text: ' ', isActive: false });
      console.log('res dir user', res);
      return res;
    },
  },

  // --- leadsTask ---
  leadsTask: {
    url: '/mechti/leads_task_template',
    byId: (id) => `/mechti/leads_task_template/${id}`,
    transform: (data) =>
      (data || []).map((d) => ({
        ...d,
        value: d.id,
        text: d.name,
        action_text: d?.data?.action_text || d.name,
      })),
  },

  // --- leadsGroup ---
  leadsGroup: {
    url: '/mechti/leads_status_group',
    byId: (id) => `/mechti/leads_status_group/${id}`,
    params: {
      sort: { key: 'name', order: 'ASC' },
    },
    transform: (data) =>
      (data || []).map((d) => ({
        ...d,
        value: d.id,
        text: d.name,
      })),
  },

  // --- adsSubAgent ---
  adsSubAgent: {
    method: 'post',
    url: '/report_sql',
    body: { name: 'getAdsSubAgentList' },
  },

  // --- adsContact ---
  adsContact: {
    method: 'post',
    url: '/report_sql',
    body: { name: 'getAdsContactList' },
  },

  // --- roles (custom) ---
  roles: {
    custom: async ({ store }) => {
      console.log('get roles');
      const r = store.getters['config/get'].userRoles;
      const names = store.getters['config/get'].config?.dictionary?.roles;

      return Object.keys(r).map((key) => {
        const id = parseInt(r[key]);
        return {
          id,
          value: id,
          text: names[id] || key,
          origin: key,
        };
      });
    },
  },

  // --- routes (custom) ---
  routes: {
    custom: async () => {
      let d = routes.routes.map((route) => ({
        value: route.name,
        text: route?.meta?.title || null,
      }));

      return d.filter((e) => e.text && !e.value.includes('_'));
    },
  },

  // --- operationTable ---
  operationTable: {
    custom: async ({ store }) => {
      const name = 'operationTable';
      const obj = store.getters['config/get'].accounting?.[name] || {};
      const operations = store.getters['config/get'].config?.dictionary?.operations;

      const d = [];

      for (const key in obj) {
        const el = obj[key];

        let text = operations[key]?.name || el.name;

        const row = {
          id: parseInt(key),
          value: parseInt(key),
          text,
          ...el,
        };

        d.push(row);
      }

      return d;
    },
  },
};
